<template>
  <div class="padded vh100 flex-center">
    <form id="register-view" class="card form form_login padded-xl w500" @submit.prevent="setPassword">
      <div>
        <img src="favicon.png" alt="" style="height: 40px; margin-bottom: 15px;"/>
      </div>
      <h1 class="display-6 mb-4">Bedenk een wachtwoord</h1>
      <transition name="fade">
          <div class="alert" v-if="msgtext" :class="msgclass" v-html="msgtext"></div>
      </transition>
      <input-default label="Wat wil je als wachtwoord?" v-model="newPassword" description="Kies minimaal 6 letters en 2 getallen"/>
      <div class="button-row">
        <button class="btn btn-primary" type="submit">Dit wordt mijn wachtwoord</button>
      </div>
    </form>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import axios from 'axios'

  import { authHeader } from '../services/auth-header.js';

  export default {
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        newPassword: '',
        returnUrl: '',
        hexEncode: this.$route.params.id,
        error: ''
      }
    },
    components: {
      InputDefault,
      AlertBar
    },
    methods: {
      setPassword(){

        const data = {
          password: this.newPassword
        }

        this.loading = true

        axios.post(process.env.VUE_APP_ROOT_API+'/resetPassword/'+this.hexEncode, data)
        .then(
          response => {
              this.msgclass = 'success'
              this.msgtext = 'Je wachtwoord is aangepast. <a href="/login">Log nu in</a>'
              this.$router.push('/login')
          },
          error => {
            this.msgtext = error,
            this.loading = false
          }
        )
      }
    }
  }
</script>